import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Bigbang/web/app/global-error.tsx");
